'use strict'

import moment from 'moment'
import router from '@/router'
import { skipChatAppDir } from '@/service/api/application'
import { message } from 'ant-design-vue'
import { aiToolsStore } from '@/store/aiToolsStore'
import { saveChatTitle } from '@/service/api/textWork.js'
import { local } from '@/utils/storage'
import eventsBus from '@/utils/eventsBus'

export function dateFormat(value, format) {
  return moment(value).format(format || 'YYYY-MM-DD')
}

export function numberFormat(value, count) {
  const temp = Number(value).toFixed(count ?? 2)
  return temp === 'NaN' ? '0.00' : temp
}

export function randoms(len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (let i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    // rfc4122, version 4 form
    let r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('') + new Date().getTime()
}

export function getFormData(data) {
  const formData = new FormData()
  data && Object.keys(data).forEach((key) => formData.append(key, data[key]))
  return formData
}

export function setAvatar(avatar) {
  return avatar
    ? avatar.startsWith('http')
      ? avatar
      : require(`@/assets/avatar/${avatar}`)
    : require(`@/assets/avatar/default.jpg`)
}
export function loadIcon(url) {
  if (!url) return ''
  if (url.startsWith('http') || url.startsWith('https')) {
    return url
  } else {
    try {
      return require(`@/assets/${url}`)
    } catch (error) {
      console.warn(`Icon not found: ${url}`, error)
      return '' // 返回空字符串而不是让页面崩溃
    }
  }
}
export function filterTree(list, condition) {
  let trees = []
  let parents = []
  for (let item of list) {
    let node
    condition(item) && (node = { ...item, children: [] })
    if (item.children) {
      const temp = filterTree(item.children, condition)
      if (temp.trees.length) {
        node ? (node.children = temp.trees) : (node = { ...item, children: temp.trees })
        parents.push(node)
        parents = parents.concat(temp.parents)
      }
    }
    node && trees.push(node)
  }
  return { trees, parents }
}

export function getTreeItem(list, condition) {
  let temp
  for (let item of list) {
    if (condition(item)) {
      temp = item
      break
    } else if (item.children) {
      temp = getTreeItem(item.children, condition)
      if (temp) break
    }
  }
  return temp
}

export function findItemWithParent(tree, condition) {
  // 定义一个递归函数
  function traverse(node, parent) {
    if (condition(node)) {
      // 如果当前节点符合条件，返回当前节点及其父节点
      return { item: node, parent }
    }
    if (node.xhsAdvertisersInfoList) {
      // 如果当前节点有子节点，递归遍历子节点
      for (let child of node.xhsAdvertisersInfoList) {
        const result = traverse(child, node) // 递归调用，传递当前节点作为父节点
        if (result) return result // 如果找到符合条件的节点，返回结果
      }
    }
    return null // 如果当前分支未找到符合条件的节点，返回 null
  }
  // 遍历根节点
  for (let root of tree) {
    const result = traverse(root, null) // 根节点的父节点为 null
    if (result) return result
  }
  return null // 如果整个树中未找到符合条件的节点，返回 null
}

export function downloadExcel(name, data) {
  const link = document.createElement('a')
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  link.download = name // 下载的文件名
  document.body.appendChild(link)
  link.click()
  URL.revokeObjectURL(link.href) //下载完成
  document.body.removeChild(link)
}

export function desensitization(value) {
  return `${value.substring(0, 3)}****${value.substring(7)}`
}

export function copyText(value) {
  const inputEl = document.createElement('input')
  inputEl.value = value
  // inputEl.style.display = 'none';
  document.body.appendChild(inputEl)
  inputEl.select()
  document.execCommand('copy')
  document.body.removeChild(inputEl)
}

export function debounce(func, delay = 1000) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.call(this, ...args)
    }, delay)
  }
}

export function processString(input) {
  if (!input) return []
  const parts = input.split('\n')

  const result = []

  parts.forEach((part) => {
    console.log(part.includes('\n'))
    if (part.includes('\n')) {
      const subItems = processString(part)
      result.push({ value: part.replace(/\n.*/, ''), children: subItems })
    } else {
      // 如果不包含\n，直接添加为当前级的值
      result.push({ value: part })
    }
  })

  return result
}
export function downloadImage(url, fileName) {
  //图片的地址
  fetch(url)
    // 获取 blob 对象
    .then((res) => res.blob())
    .then((blob) => {
      // 创建a标签
      let link = document.createElement('a')
      // 设置a标签为不可见
      link.style.display = 'none'
      // 将a标签添加到body
      document.body.appendChild(link)
      // 生成Blob URL并设置给a标签的href属性
      let url = window.URL.createObjectURL(blob)
      link.href = url
      // 设置a标签的download
      link.download = fileName
      // 模拟点击事件进行下载
      link.click()
      //下载完成后清理URL对象和a标签
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    })
}

export function formatStorage(sizeInKB, toFixedNum = 2) {
  let sizeInBytes = sizeInKB * 1024 // 将 KB 转换为 bytes
  if (sizeInBytes >= 1024 * 1024 && sizeInBytes < 1024 * 1024 * 1024) {
    // 大于或等于 1 MB
    return (sizeInBytes / (1024 * 1024)).toFixed(toFixedNum) + ' MB'
  } else if (sizeInBytes >= 1024 * 1024 * 1024 && sizeInBytes < 1024 * 1024 * 1024 * 1024) {
    // 大于或等于 1 GB
    return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(toFixedNum) + ' GB'
  } else if (sizeInBytes >= 1024 * 1024 * 1024 * 1024) {
    // 大于或等于 1 GB
    return (sizeInBytes / (1024 * 1024 * 1024 * 1024)).toFixed(toFixedNum) + ' TB'
  } else {
    // 小于 1 MB
    return Number(sizeInKB).toFixed(toFixedNum) + ' KB'
  }
}

export function gcd(a, b) {
  if (b == 0) return a
  return gcd(b, a % b)
}
export function matchFileExtension(filename) {
  // 提取文件后缀（小写化，避免大小写问题）
  const extension = filename.split('.').pop().toLowerCase()
  // 匹配规则
  if (['xls', 'xlsx'].includes(extension)) {
    return 'xlsx'
  } else if (['ppt', 'pptx'].includes(extension)) {
    return 'ppt'
  } else if (['doc', 'docx', 'md', 'txt'].includes(extension)) {
    return 'text'
  } else if (extension === 'pdf') {
    return 'pdf'
  } else if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'svg'].includes(extension)) {
    return 'image'
  } else if (['mp4', 'mov', 'm4a', 'wav', 'webm', 'avi', 'mkv'].includes(extension)) {
    return 'video'
  } else {
    return 'other'
  }
}

export function getFileName(link, defaultName = 'unknown') {
  const legalized = link.replace(/%(?![0-9a-fA-F]{2})/g, '%25')
  const imgLink = decodeURIComponent(legalized)
  try {
    if (imgLink.startsWith('data:')) return defaultName
    return imgLink.split('/').pop().split('?')[0].split('#')[0] || defaultName
  } catch {
    // 非法 URL 退回到“纯字符串”方案
    return imgLink.split('/').pop().split('?')[0].split('#')[0] || defaultName
  }
}
export function simplifyRatio(width, height) {
  const greatestCommonDivisor = gcd(width, height)
  const simplifiedWidth = width / greatestCommonDivisor
  const simplifiedHeight = height / greatestCommonDivisor
  return {
    w: simplifiedWidth,
    h: simplifiedHeight
  }
}

export function getImageDimensions(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = imageUrl
    img.onload = () => {
      resolve({
        w: img.width,
        h: img.height
      })
    }
    img.onerror = (error) => {
      reject(new Error(`Failed to load image: ${error.message}`))
    }
  })
}
export function convertImgToBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous' // 允许跨域图像加载
    img.src = url

    img.onload = function () {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight
      ctx.drawImage(img, 0, 0)
      const base64 = canvas.toDataURL('image/png') // 或者 image/jpeg 根据需要
      resolve({
        base64: base64,
        width: img.naturalWidth,
        height: img.naturalHeight
      })
    }

    img.onerror = function () {
      reject(new Error('Failed to load image'))
    }
  })
}

export function applicationJump(item) {
  //收藏字段处理
  item.aiCode = item.aiCode || item.jsonData?.aiCode || null
  //type: 1-工作流 2-应用 3-AI应用 4-大脑
  const obj = {
    CHAT: 'Dialogue',
    IMAGE: 'GenerateImage',
    VIDEO: 'GenerateVideo',
    AIGC: 'AiDAM',
    AICUT: 'videoEditingCreateProject',
    AI_ONE_CLICK: 'aiVideoGenerationCreateProject',
    ASK_REPORT: 'aiSearchSingle',
    CONTENT_WRITING: 'aiAgent',
    CASELIB: 'InspirationLibrary'
  }
  const paramsMap = {
    CONTENT_WRITING: {
      code: 'news'
    }
  }
  const store = aiToolsStore()
  if (item.type == 4 && item.aiCode === 'CREATE_BRAIN') {
    router.push({
      name: 'VideoRetrieval'
    })
  } else if (item.type == 4 && item.aiCode === 'REPORT') {
    router.push({
      name: 'Report'
    })
  } else if (item.type == 4 && obj[item.aiCode]) {
    router.push({
      name: obj[item.aiCode],
      params: {
        ...paramsMap[item.aiCode]
      }
    })
  } else if (item.type == 3 && obj[item.aiCode]) {
    store.activeKey = 'textWork'
    if (item.aiCode === 'CHAT') {
      saveChatTitle({
        userId: local.get('TOKEN').id,
        type: 'TEXT',
        modeId: '10',
        title: `AI会话`
      }).then(() => {
        eventsBus.emit('updateChatList')
        router.push({
          name: 'Dialogue'
        })
      })
    } else {
      router.push({
        name: obj[item.aiCode]
      })
    }
  } else if (item.type == 2) {
    skipChatAppDir({ appId: item.cappId || item.jsonData?.appId }).then((res) => {
      if (res.data) {
        store.activeKey = 'textWork'
        if (item.aiCode === 'VIDEO') {
          router.push({
            name: 'GenerateVideo'
          })
          //  GenerateImage 图片
        } else if (item.aiCode === 'IMAGE') {
          router.push({
            name: 'GenerateImage'
          })
        } else {
          message.success('添加成功')
          eventsBus.emit('updateChatList')
          router.push({
            name: 'Dialogue'
          })
        }
      }
    })
  } else if (item.type === 1) {
    // 工作流运行页面
    router.push({
      name: 'ScriptRunning',
      params: {
        id: item.jsonData?.id || item.id,
        executeCode: 'new'
      }
    })
  }
}

export function applicationJumpT(item) {
  //type: 1-工作流 2-应用 3-AI应用 4-大脑
  if (item.type == 4 && item.aiCode === 'CREATE_BRAIN') {
    router.push({
      name: 'VideoRetrieval'
    })
  } else if (item.type == 4 && item.aiCode === 'CREATE_BRAIN_SHUCAI') {
    router.push({
      name: 'materialRetrieval'
    })
  } else if (item.type == 4 && item.aiCode === 'REPORT') {
    router.push({
      name: 'Report'
    })
  } else if (item.type == 4 && item.aiCode === 'ASK_REPORT') {
    router.push({
      name: 'aiSearchSingle'
    })
  } else if (item.type == 4 && item.aiCode === 'AICUT') {
    router.push({
      name: 'videoEditingCreateProject'
    })
  } else if (item.type == 4 && item.aiCode === 'AI_ONE_CLICK') {
    router.push({
      name: 'aiVideoGenerationCreateProject'
    })
  } else if (item.type == 4 && item.aiCode === 'CONTENT_WRITING') {
    router.push({
      name: 'aiAgent',
      params: {
        code: 'news'
      }
    })
  } else if (item.type == 3 && item.aiCode === 'CASELIB') {
    router.push({
      name: 'InspirationLibrary'
    })
  } else if (item.type == 3) {
    router.push({
      name: 'ScriptRunning',
      params: {
        id: item.jsonData?.id || item.children.id,
        executeCode: 'new'
      }
    })
  } else if (item.type == 2) {
    if (item.aiCode === 'VIDEO') {
      router.push({
        name: 'GenerateVideo'
      })
      //  GenerateImage 图片
    } else if (item.aiCode === 'IMAGE') {
      router.push({
        name: 'GenerateImage'
      })
    } else if (item.aiCode === 'AIGC') {
      router.push({
        name: 'AiDAM'
      })
    } else if (item.aiCode === 'CASELIB') {
      router.push({
        name: 'InspirationLibrary'
      })
    } else {
      router.push({
        name: 'Dialogue'
      })
    }
  } else if (item.type === 1) {
    skipChatAppDir({ appId: item.cappId || item.children.id }).then((res) => {
      if (res.data) {
        if (item.aiCode === 'VIDEO') {
          router.push({
            name: 'GenerateVideo'
          })
          //  GenerateImage 图片
        } else if (item.aiCode === 'IMAGE') {
          router.push({
            name: 'GenerateImage'
          })
        } else {
          // message.success('添加成功')
          router.push({
            name: 'Dialogue'
          })
        }
      }
    })
  }
}
/* 工具：在光标处插入文本并重新聚焦 */
export function insertAtCursor(textarea, str) {
  const start = textarea.selectionStart
  const end = textarea.selectionEnd
  textarea.setRangeText(str, start, end, 'end')
  textarea.focus()
}

export function getScrollBottom(element) {
  return element.scrollHeight - element.scrollTop - element.clientHeight
}
// 计算两个数的比值并输出为“几比几”的格式
export function calculateRatio(a = 1, b = 1) {
  if (b === 0) {
    return null // 避免除以零的错误
  }
  const greatestCommonDivisor = gcd(a, b)
  const simplifiedA = a / greatestCommonDivisor
  const simplifiedB = b / greatestCommonDivisor
  return `${simplifiedA}:${simplifiedB}`
}
